"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNotificationCloseButton = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var CloseButton_1 = __importDefault(require("../../../components/CloseButton"));
exports.StyledNotificationCloseButton = styled_components_1.default(CloseButton_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n"], ["\n  ", ";\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n"])), style_utils_1.setPadding("top", 1));
var NotificationCloseButton = function (_a) {
    var closeToast = _a.closeToast;
    var onClick = function (e) {
        e.stopPropagation();
        closeToast(e);
    };
    return (react_1.default.createElement(exports.StyledNotificationCloseButton, { toggle: onClick },
        react_1.default.createElement("span", null, "\u00D7")));
};
exports.default = NotificationCloseButton;
var templateObject_1;
//# sourceMappingURL=index.js.map